import React, { HTMLProps } from "react";
import styled from "styled-components";

import Avatar from "../../../../../components/Avatar";
import { ApiCategory, ApiProfile } from "../../../../../types";

const AddButtonCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: #e1e5e9;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CompetitorList = ({ ...props }: HTMLProps<HTMLDivElement>) => (
  <div className="d-flex flex-wrap justify-content-center" {...props} />
);

type ItemProps = { profile: ApiProfile; category: ApiCategory };

export const CompetitorListItem = ({
  profile,
  category,
  ...props
}: ItemProps & HTMLProps<HTMLDivElement>) => (
  <div
    className="d-flex flex-column align-items-center justify-center me-3"
    {...props}
  >
    <Avatar
      user={{
        name: profile.firstName + " " + profile.lastName,
        pictureUrl: profile.pictureUrl,
        uuid: profile.uuid,
      }}
    />
    <div
      className="fw-bold text-truncate text-overflow text-center"
      style={{ width: 140 }}
    >
      {profile.firstName} {profile.lastName}
    </div>
    <small className="muted">{category.name}</small>
    <div className="text-primary small">Edit</div>
  </div>
);

export const AddButton = ({ ...props }: HTMLProps<HTMLDivElement>) => (
  <div
    className="d-flex flex-column align-items-center justify-center"
    style={{ width: 140 }}
    {...props}
  >
    <AddButtonCircle>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.2999 15.7V9.70002H0.274902V6.30002H6.2999V0.275024H9.6999V6.30002H15.7249V9.70002H9.6999V15.7H6.2999Z"
          fill="#69738A"
        />
      </svg>
    </AddButtonCircle>
    <strong>Add Competitor</strong>
  </div>
);
